module.exports = __webpack_public_path__ + "static/media/logo-white.33860e81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.svg
// module id = 1648
// module chunks = 0